<template>
  <div class="element-details-card-header">
    <element-details-config-button :el="el" config="show-subTasks"></element-details-config-button>
  </div>

  <div class="mt-2"></div>
  <select-element v-model="newSubTasks" :items="filteredSubTasks" multiple @update:model-value="addSubTask"></select-element>

  <template v-if="elSubTasks.length">
    <div class="mt-3 pr-4 milestones-inline d-flex column-gap-6 row-gap-4 flex-wrap">
      <div v-for="(subTask, subTaskIndex) in elSubTasks">
        <planning-element-view :el="subTask" :show-details-items="['progress', 'dates', 'date']" class="flex-grow-1 nobr"
                               style="position: relative; font-size: 75%; max-width: 220px" disable-mini-element disable-styling>
          <template #hover-menu>
            <div class="element-menu" :style="{ left: '100%', top: 0, 'margin-top': subTask.isType('macro', 'task') && subTask.hasIcon() ? '22px' : '0' }" @click.stop>
              <v-btn icon size="x-small" variant="outlined" :title="subTask.isType('milestone') ? $t('ELEMENT-DETAIL.MACRO.REMOVE_MILESTONE') : $t('ELEMENT-DETAIL.MACRO.REMOVE_TASK')"
                     @click="removeSubTask(subTaskIndex)">
                <v-icon size="large" color="errorred">far fa-times</v-icon>
              </v-btn>
            </div>
          </template>
        </planning-element-view>
      </div>
    </div>
  </template>
</template>

<script>
  import { computed } from 'vue';
  import PlanningElementView from '@/components/Planning/PlanningElementView.vue';
  import SelectElement from '@/components/Reusables/SelectElement.vue';
  import ElementDetailsConfigButton from '../partials/ElementDetailsConfigButton.vue';
  import { useMacroParents } from './useMacroParents.js';

  export default {
    components: {
      PlanningElementView,
      SelectElement,
      ElementDetailsConfigButton,
    },
    props: {
      el: { type: Object, required: true },
    },
    setup(props) {
      const elements = computed(() => props.el.getPlanning().elements);
      const { getMacroParentsSet } = useMacroParents(elements);
      return {
        getMacroParentsSet,
      };
    },
    data() {
      return {
        newSubTasks: null,
        planning: this.el.getPlanning(),
      };
    },
    computed: {
      elSubTasks() {
        if (! this.el.isType('macro')) return null;
        if (! this.el.getSubTasks()?.length) return [];
        const subElementsById = new Map();
        this.planning.elements.forEach((item) => { if (this.elSubTasksId.has(parseInt(item.id, 10))) subElementsById.set(parseInt(item.id, 10), item); });
        return this.el.getSubTasks().reduce((acc, id) => { // keep selection order
          const subTask = subElementsById.get(parseInt(id, 10));
          if (subTask) acc.push(subTask);
          return acc;
        }, []);
      },
      elSubTasksId() {
        return new Set(this.el.getSubTasks());
      },
      elParentsIds() {
        return this.getMacroParentsSet(this.el.id);
      },
      filteredSubTasks() {
        const filteredSubTasks = { task: [], milestone: [], macro: [] };
        this.planning.elements.forEach((el) => {
          if (this.elParentsIds.has(el.id)) return; // ignore parents of selected macro
          if (this.elSubTasks.find(item => item.id == el.id)) return;
          filteredSubTasks[el.getType()].push(el);
        });
        Object.values(filteredSubTasks).forEach((els) => { els.sort((a, b) => (a.getStartTime() < b.getStartTime() ? -1 : 1)); });
        const result = [];
        if (filteredSubTasks.task.length) result.push({ header: this.$t('GLOBAL.BUBBLES'), id: 'headertask' }, ...filteredSubTasks.task);
        if (filteredSubTasks.milestone.length) result.push({ header: this.$t('GLOBAL.MILESTONES'), id: 'headermilestone' }, ...filteredSubTasks.milestone);
        if (filteredSubTasks.macro.length) result.push({ header: this.$t('GLOBAL.MACRO_BUBBLES'), id: 'headermacro' }, ...filteredSubTasks.macro);
        return result;
      },
      planningLocale() {
        return this.planning.timeline.getTimelocale();
      },
    },
    methods: {
      addSubTask() {
        this.elSubTasks.push(...this.newSubTasks); // using multiple to keep menu opened
        const subTasksId = this.elSubTasks.map(item => item.o_id || item.id);
        this.el.setSubTasks(subTasksId);
        this.$nextTick(() => {
          this.newSubTasks = null;
        });
      },
      removeSubTask(index) {
        if (index > -1 && index < this.elSubTasks.length) {
          this.elSubTasks.splice(index, 1);
          const subTasksId = this.elSubTasks.map(item => item.o_id || item.id);
          this.el.setSubTasks(subTasksId);
          this.$nextTick(() => {
            this.newSubTasks = null;
          });
        }
      },
      defaultTitle(el) {
        return this.$t('helpers.elDefaultTitle', { type: el.getType() });
      },
    },
  };
</script>
